import { render } from "./LoadOldMessage.vue?vue&type=template&id=2880c47d&scoped=true"
import script from "./LoadOldMessage.vue?vue&type=script&lang=js"
export * from "./LoadOldMessage.vue?vue&type=script&lang=js"

import "./LoadOldMessage.vue?vue&type=style&index=0&id=2880c47d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2880c47d"]])

export default __exports__